import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { competitionSchedule } from "../../services/Competition";
import CustomSnackbar from "../../CustomSnackbar";

const NotificationDialog = ({ openDialog, setOpenDialog, competitionId, setSchedules }) => {
  const [value, setValue] = useState(dayjs());
  const [winnerMessage, setWinnerMessage] = useState("");
  const [notifyTo, setNotifyTo] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [errors, setErrors] = useState({});
  const formatDate = (date) => date.format("YYYY-MM-DD HH:mm:00");

  const handleDeclare = () => {
    if (!competitionId) return;

    // API Call
    const data = {
      scheduled_on: formatDate(value),
      notify_to: notifyTo,
      notification_message: winnerMessage.trim(),
    };
    console.log("data", data);

    competitionSchedule(competitionId, data)
      .then((res) => {
        console.log("Competition notification scheduled successfully:", res);
        setMessage(res.message || "Winner announcement scheduled successfully!");
        setSeverity("success");
        setOpenDialog(false);
        //optimistic update
        setSchedules((prev) => [...prev, res.data]);

      })
      .catch((err) => {
        console.error("Error scheduling notification:", err);
        setMessage(err.message || "Failed to schedule. Please try again.");
        setSeverity("error");
        setErrors(err.errors);
      });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setMessage("");
    setSeverity("");
    setErrors({});
  };


  return (
    <React.Fragment>
      <CustomSnackbar
        open={!!message}
        message={message}
        severity={severity}
        onClose={() => setMessage("")}
      />

      <Dialog open={openDialog} onClose={handleCloseDialog}
        maxWidth="md" fullWidth>
        <DialogTitle sx={{ pb: 0 }}>Schedule Notification</DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </IconButton>

        <DialogContent sx={{ pt: 1 }}>
          <Grid container spacing={2}>
            {/* Notify To */}
            <Grid size={12}>
              <FormControl fullWidth size="small">
                <FormLabel>Notify To</FormLabel>
                <RadioGroup
                  row
                  value={notifyTo}
                  onChange={(e) => setNotifyTo(e.target.value)}
                >
                  <FormControlLabel value="all" control={<Radio />} label="All" />
                  <FormControlLabel value="all_evaluators" control={<Radio />} label="All Evaluators" />
                  <FormControlLabel value="all_participants" control={<Radio />} label="All Participants" />
                  <FormControlLabel value="top-01" control={<Radio />} label="Top 1" />
                  <FormControlLabel value="top-03" control={<Radio />} label="Top 3" />
                  <FormControlLabel value="top-10" control={<Radio />} label="Top 10" />
                  <FormControlLabel value="winning_evaluators" control={<Radio />} label="Winning Evaluators" />
                </RadioGroup>
                {errors?.notify_to?.[0] && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    {errors?.notify_to?.[0]}
                  </Typography>
                )}
              </FormControl>
            </Grid>


            {/* Message Field */}
            <Grid size={12}>
              <FormControl fullWidth size="small">
                <FormLabel>Message</FormLabel>
                <TextField
                  placeholder="Enter message here"
                  value={winnerMessage}
                  onChange={(e) => setWinnerMessage(e.target.value)}
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  margin="normal"
                  error={Boolean(errors?.notification_message)}
                  helperText={errors?.notification_message?.[0] || ""}
                />
              </FormControl>
            </Grid>


            {/* Date Picker */}
            <Grid size={{ xs: 12, sm: 6 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDatePicker
                  displayStaticWrapperAs="desktop"
                  value={value}
                  onChange={(newValue) => setValue(newValue)}
                />
              </LocalizationProvider>
              {errors?.scheduled_on?.[0] && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                  {errors?.scheduled_on?.[0]}
                </Typography>
              )}
            </Grid>

            {/* Time Picker */}
            <Grid size={{ xs: 12, sm: 6 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticTimePicker
                  displayStaticWrapperAs="desktop"
                  value={value}
                  onChange={(newValue) => setValue(newValue)}
                />
              </LocalizationProvider>
              {errors?.scheduled_on?.[0] && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                  {errors?.scheduled_on?.[0]}
                </Typography>
              )}
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={handleDeclare}
            disableElevation
            sx={{ textTransform: "none" }}
            color="primary"
          >
            Schedule Now
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NotificationDialog;